import { padding } from "@mui/system";
import { Colors } from "assets/colors";
import { styles as inputStyles } from "common/inputStyles";

export const styles: any = {
  container: {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "70vw",
    bgcolor: 'background.paper',
    boxShadow: 24,
    height: "max-content",
    overflowY: "auto",
    borderRadius: "5px",
    p: 3
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: Colors.GrayText,
    "& svg": {
      cursor: "pointer"
    },
    "& h2": {
      marginBottom: "1rem"
    }
  },
  actionHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: "1rem"
  },
  select: {
    paddingTop: 0
  },
  uploadContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    height: "auto",
    width: "1120px",
    border: `1px dashed ${Colors.Green}`,
    borderRadius: "5px",
    marginTop: "1rem",
    backgroundColor: Colors.GreenIconBox
  },
  cancelButton: {
    ...inputStyles.buttonGreenOutline,
    padding: ".3rem 1.5rem",
    marginRight: ".5rem"
  },
  addButton: {
    ...inputStyles.buttonGreen,
    padding: ".3rem 1.5rem",
    minWidth: "max-content !important"
  },
  CSVDLoadBtn: {
    ...inputStyles.buttonGreen,
    padding: ".4rem 1rem",
    minWidth: "max-content !important"
  },
  text: {
    fontSize: "1rem",
    fontWeight: 700,
    marginBottom: ".1rem",
    display: "flex",
    alignItems: "center"
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    margin: "1.5rem 0 0 0"
  },
  
} 
